<template>

    <el-dialog
        :visible.sync="dialogMessage"
        class="dialog-wrapper"
        custom-class="dialog-message"
        :append-to-body="true"
        :show-close="false"
        :close-on-click-modal="close_dialog"
        @closed="onClear"
        :close-on-press-escape="true"
        lock-scroll>
        <template slot="title">
            <div v-if="type !== 'loading'" class="flex justify-end">
                <el-button  @click="dialogMessage=false" size="small" class="text-navy bg-secondary-light hover:bg-gray-100 p-1 rounded-full mt-2 mr-2" type="text"><i class="las la-times text-lg-scale"></i></el-button>
            </div>
            <div v-else class="flex justify-start p-2 xs:p-4">
                <span class="text-lg-scale font-semibold">Please wait!</span>
            </div>
        </template>
       <div class="flex justify-center">
            <img :width="width" :src="dialogImg">
        </div>
        <div class="text-center w-full mt-1 mb-6">
            <div v-html="dialogContent" class="w-full text-center"></div>
        </div>
    </el-dialog>

</template>

<script>
export default {
    name: "DialogMessage",
    data(){
        return{dialogMessage:false,dialogImg:'',dialogContent:'',width:'',type:'',close_dialog:false}
    },
    created() {},
    mounted() {},
    methods:{
        onOpenMessage(img,content,type,visible) {

            this.dialogImg = null;
            type === 'loading'?this.width = 140 : type === 'error'? this.width = 80 : this.width = 80;
            type === 'loading'?this.close_dialog = false : this.close_dialog = true;
            this.type = type;
            this.dialogImg = img;
            this.dialogContent = content;
            if(visible){
                this.dialogMessage = visible;
            }else {
                if(type === 'success'){
                    setTimeout(()=>{this.dialogMessage = visible;},1000);
                }else{
                    this.dialogMessage = visible;
                }
            }
        },

        onClear(){
            this.type = '';
            this.dialogImg = '';
            this.dialogContent = '';
            //this.$refs.dialogRef.$el.remove(); // Remove the dialog from the DOM
            //this.$refs.dialogRef = null;
        },
    },
}
</script>

<style scoped>

div >>>.dialog-message .el-dialog__header {
    padding: 0;
}
div>>>.dialog-message .el-dialog__body{
    padding: 0 15px 0px 15px !important;

}
div>>>.dialog-message{
    width: 95% !important;
}

@media (min-width: 576px) {

}
@media (min-width: 768px) {
    div>>>.dialog-message{
        width: 55% !important;
    }
    div>>>.dialog-message .el-dialog__body{

        padding: 0 15px 0px 15px !important;
    }
}
@media (min-width: 992px) {

}
@media (min-width: 1200px) {
    div>>>.dialog-message{
        width: 35% !important;
    }
}
@media (min-width: 1440px){
    div>>>.dialog-message{
        width: 32% !important;
    }
}
@media (min-width: 1920px){
    div>>>.dialog-message{
        width: 25% !important;
    }
}
@media (min-width: 2500px){
    div>>>.dialog-message{
        width: 20% !important;
    }
}
</style>
